// §2.6 Playhead: 2px accent line with a triangular head. position: 0..1 (computed geometry).
export default function Playhead({ position = 0 }) {
  return <span className="ui ui-playhead" style={{ left: `${Math.min(1, Math.max(0, position)) * 100}%` }} aria-hidden="true" />;
}
